import React, { useContext, useMemo } from 'react';

import DatasetDefinitionsContext from 'contexts/DatasetDefinitionsContext';
import FormInput from 'kingpin/forms/FormInput';

import FieldsListHeading from '../DatasetFieldPicker/FieldsListHeading';
import FieldsList from '../DatasetFieldPicker/FieldsList';

/**
 * Field picker for the per-week fact table shown beneath the Bonus Reward / Bonus
 * Total Reward sections on sub-period programs. The dataset is fixed to the
 * selected bonus program's output dataset, so this only offers the field list
 * (no dataset dropdown). Renders nothing until a program is chosen.
 */
const FactTableFieldsInput = ({
  bonusConfigId,
  fields,
  setFields,
}: {
  bonusConfigId: string | undefined;
  fields: string[];
  setFields: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
  const { bonusPrograms } = useContext(DatasetDefinitionsContext);

  const dataset = useMemo(
    () =>
      bonusPrograms.find((program) => program.id === bonusConfigId)?.dataset,
    [bonusPrograms, bonusConfigId],
  );

  if (!dataset) {
    return null;
  }

  return (
    <FormInput label={'Weekly breakdown fields'}>
      <FieldsListHeading
        fields={fields}
        setFields={setFields}
        dataset={dataset}
      />
      <FieldsList fields={fields} setFields={setFields} />
    </FormInput>
  );
};

export default FactTableFieldsInput;
